import ReactDOM from "react-dom/client";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App, { AppContextProvider, AuthContextProvider, TutorialContextProvider } from "./App.tsx";

import Dashboard from "./components/Dashboard/Dashboard.tsx";
import Account from "./components/Account/Account.tsx";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Auth0ProviderWithNavigate } from "./Auth0ProviderWithNavigate.tsx";
import Downloads from "./components/Downloads/Downloads.tsx";

import PentestWindows from "./components/PentestWindows/PentestWindows.tsx";
import ButtonShowcase from "./components/Common/Button/ButtonShowcase.tsx";

import React from "react";

import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

import * as Sentry from "@sentry/react";

function initPosthog() {
  if (import.meta.env.PROD)
    posthog.init("phc_4D98ootJTPvdHiZ9aL3IYxmw6u89zKaxaq0roskc4WR", {
      api_host: "https://eu.i.posthog.com",
    });
  else console.log("Dev environment, posthog init skipped");
}

function initSentry() {
  Sentry.init({
    dsn: "https://c464e761013b7797096b2b4bbec86161@o4508859861499904.ingest.de.sentry.io/4508860121415760",

    integrations: [Sentry.replayIntegration()],

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    // Custom session sampling
    tracesSampler: (samplingContext) => {
      const user = samplingContext?.customSamplingContext?.user;
      if (user?.email?.includes("@pentra.ai")) { // Disable traces for playwright account
        return 0.0; // Don't record replays
      }
      return 1.0; // Normal sampling for others
    },

    enabled: import.meta.env.PROD,
  });
}

if (typeof window !== "undefined") {
  window.addEventListener("load", () => {
    setTimeout(initPosthog, 100);
    setTimeout(initSentry, 100);
  });
}

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <App />,
      children: [
        {
          path: "/",
          element: <Dashboard />,
        },
        {
          path: "/pentest",
          element: <PentestWindows />,
        },
        {
          path: "/account",
          element: <Account settings={false} />,
        },
        {
          path: "/settings",
          element: <Account settings={true} />,
        },
        {
          path: "/downloads",
          element: <Downloads />,
        },
        {
          path: "/button-styles",
          element: <ButtonShowcase />,
        },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  },
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <Auth0ProviderWithNavigate>
        <AppContextProvider>
          <AuthContextProvider>
            <TutorialContextProvider>
              <RouterProvider router={router} future={{ v7_startTransition: true }} />
            </TutorialContextProvider>
          </AuthContextProvider>
        </AppContextProvider>
      </Auth0ProviderWithNavigate>
    </PostHogProvider>
  </React.StrictMode>,
);
